import { gql } from "@apollo/client";
import { CARE_ASSISTANT_DIPLOMA_FIELDS } from "../queries/careAssistantDiplomas";

export const CREATE_CARE_ASSISTANT_DIPLOMA = gql`
  mutation CreateCareAssistantDiploma(
    $input: UpdateCareAssistantDiplomaInput!
  ) {
    createCertCareAssistantDiploma(input: $input) {
      ...CareAssistantDiplomaFields
    }
  }
  ${CARE_ASSISTANT_DIPLOMA_FIELDS}
`;

export const UPDATE_CARE_ASSISTANT_DIPLOMA = gql`
  mutation UpdateCareAssistantDiploma(
    $id: ID!
    $input: UpdateCareAssistantDiplomaInput!
  ) {
    updateCertCareAssistantDiploma(id: $id, input: $input) {
      ...CareAssistantDiplomaFields
    }
  }
  ${CARE_ASSISTANT_DIPLOMA_FIELDS}
`;

export const DELETE_CARE_ASSISTANT_DIPLOMA = gql`
  mutation DeleteCareAssistantDiploma($id: ID!) {
    deleteCertCareAssistantDiploma(id: $id) {
      id
    }
  }
`;
